export default __webpack_public_path__ + "static/media/project_img_5.0cd4c0de.jpeg";